<template>
    <footer class="footer pt-3  ">
        <div class="container-fluid">
            <div class="row align-items-center justify-content-lg-between">
                <div class="col-lg-6 mb-lg-0 mb-4">
                    
                </div>

                <div class="col-lg-6 mb-lg-0 mb-4">
                    <div class="copyright text-center text-sm text-muted text-lg-end">
                        © {{Year}}
                        made with <i class="fa fa-heart" aria-hidden="true"></i> by
                        <a href="#" class="font-weight-bold" target="_blank">Lugar Creativo</a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import moment from 'moment'


export default {
    name: 'Foot',
    props: [""],
    components:{
    },
    data() {
        return {
            Year: moment(new Date()).format('YYYY'),
        }
    },
    methods: {
        },
    created() {
    },
}

</script>